module.exports = __webpack_public_path__ + "static/media/  (81).0f9c9459.jpg";